import styled, { keyframes } from 'styled-components';
import colors from '../../../helpers/colors';
import CtaArrow  from '../../../resources/images/cta-arrow.svg';
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';


// Define the bounce animation using keyframes
const bounce = keyframes`
    0%, 20%, 50%, 80%, 100% {
        transform: translateX(0);
    }
    40% {
        transform: translateX(7px);
    }
    60% {
        transform: translateX(4px);
    }
`;

const CTAButton = styled.a`
    background: ${colors.mvOrangeCta};
    text-transform: none;
    font-size: 16px;
    font-weight: bold;
    padding: 11px 15px 11px 20px;
    border-radius: ${props => props.$borderRadius};
    color: ${colors.mvWhite};
    cursor: pointer;
    border: none;
    text-decoration: none;
    transition: .3s;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;
    max-width:  ${props => props.$maxWidth};

    .cta__icon {
        background: ${colors.mvWhite};
        color: ${colors.mvDarkGrey};
        font-weight: 900;
        padding: 8px 10px;
        border-radius: 4px;
        margin-left: 13px;
    }
    a {
        text-decoration: none;
        color: ${colors.mvWhite};
    }
    &:hover {
        text-decoration: none;
        background: #FF8622;
        transition: .4s;

        .cta__icon {
            animation: ${bounce} 1s linear infinite;
        }

        a {
            text-decoration: underline;
            color: ${colors.mvDarkGrey};
        }
    }
`;

const CtaContrast = ({ctaHref, ctaText, maxWidth, newTab, onClick }) => {
    return (
        <CTAButton onClick={onClick} target={newTab} href={ctaHref} $maxWidth={maxWidth}>
            {ctaText}
            <img src={CtaArrow} className="cta__icon" alt="test" />
            {/* <FontAwesomeIcon icon={faChevronRight} className="cta__icon" alt="Icon pointing right" style={{marginLeft: '13px'}} /> */}
        </CTAButton>
    )
}

CTAButton.defaultProps = {
    $maxWidth: '180px'
};

export default CtaContrast;
